import { NgClass } from "@angular/common";
import { Component, effect, EventEmitter, inject, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { ContactCreated, PotentialContact, SharedContactRepository, SharedPendingCivilianContactRepository, UserStore } from "@shared/src/public-api";
import { debounceTime, distinctUntilChanged, Subject } from "rxjs";

@Component({
	selector: "jhm-add-contact",
	imports: [
		FormsModule,
		MatFormFieldModule,
		MatInputModule,
		NgClass
	],
	templateUrl: "./add-contact.component.html",
	styleUrl: "./add-contact.component.scss"
})
export class AddContactComponent {
	@Input()
	public createNewContact: boolean = false;
	@Output()
	public exit: EventEmitter<ContactCreated> = new EventEmitter<ContactCreated>();
	public contactSearchPlaceholder: string = "Search by email or full name.";
	public userType: string;

	readonly userStore = inject(UserStore);
	public searchQuery: string = "";
	public searching: boolean = false;
	public potentialContacts: PotentialContact[] = [];
	public searchQueryUpdate: Subject<Event> = new Subject<Event>();
	public emailToBeAdded: string = "";

	public constructor(private contactRepository: SharedContactRepository,
		private pendingCivilianContactRepository: SharedPendingCivilianContactRepository) {
		this.searchQueryUpdate.pipe(
			debounceTime(500),
			distinctUntilChanged())
			.subscribe(() =>
			{
				this.updateSearchData();
			});

		effect(() => {
			this.userType = this.userStore.type();
			if(this.userType === "CIVILIAN")
			{
				this.contactSearchPlaceholder = "Search by booking number or full name";
			}
			else if (this.userType === "INMATE")
			{
				this.contactSearchPlaceholder = "Search by name or booking number...";
			}
		})
	}

	public addContact(contactUserId: string): void
	{
		this.contactRepository.createContact(contactUserId).subscribe(() =>
		{
			this.exit.emit({
				alreadyExisted: true,
				contactUserId: contactUserId,
				email: null
			});
			this.updateSearchData();
		});
	}

	private updateSearchData(): void
	{
		if (this.searchQuery)
		{
			this.searching = true;
			this.contactRepository.getPotentialContacts(this.searchQuery)
				.subscribe((potentialContacts: PotentialContact[]) =>
				{
					this.searching = false;
					this.potentialContacts = potentialContacts;
				});
		}
		else
		{
			this.potentialContacts = [];
		}
	}

	public createContact(): void
	{
		// TODO: do we need to check the validity of the email?
		this.pendingCivilianContactRepository.createPendingCivilianContact(this.emailToBeAdded).subscribe(() =>
		{
			this.emailToBeAdded = "";
			this.exit.emit({
				alreadyExisted: false,
				contactUserId: null,
				email: this.emailToBeAdded
			});
			this.createNewContact = false;
		});
	}

	public cancelAddContact(): void
	{
		this.createNewContact = false;
		this.exit.emit(null);
	}
}
